import { gameState } from "appworks/model/game-state";
import { Gameplay } from "appworks/model/gameplay/gameplay";
import { commsManager } from "appworks/server/comms-manager";
import { SlingoResponse } from "slingo/integration/slingo-schema";
import { SlingoLadderResult } from "slingo/model/results/slingo-ladder-result";
import { SlotSpinRecordBuilder } from "slot/integration/builders/records/slot-spin-record-builder";
import { SlotSpin } from "slot/integration/slot-schema";
import { FreespinRecord } from "slotworks/model/gameplay/records/freespin-record";
import { LineResult } from "slotworks/model/gameplay/records/results/line-result";
import { FreespinRequestPayload } from "slotworks/model/gameplay/requests/freespin-request-payload";
import { slotDefinition } from "slotworks/model/slot-definition";

export class FowlSlotRecordBuilder extends SlotSpinRecordBuilder {
    public id: string = "FowlSlotRecordBuilder";

    public filter(request: any, response: any): boolean {
        const data = response?.data as SlingoResponse;
        return Boolean(data?.spinResult?.feature?.slots);
    }

    public build(gameplay: Gameplay, request: any, response: any): FreespinRecord[] {
        const data = response.data as SlingoResponse;
        const records: FreespinRecord[][] = [];
        const ladderResult = gameplay.getLatestResultOfType(SlingoLadderResult);

        const spins = data.spinResult.feature.slots.spins as SlotSpin[];
        spins.forEach((spin: SlotSpin) => {
            const fakeResponse = {
                data: {
                    spins: [spin],
                },
            };
            const baseRecord = super.build(gameState.getCurrentGame(), null, fakeResponse)[0];

            const record = new FreespinRecord();
            record.grid = baseRecord.grid;
            record.cashWon = baseRecord.cashWon;
            record.reelset = slotDefinition.reelsets.get("slotbonus_" + ladderResult.total);
            record.results = baseRecord.results;

            // Filter out and ignore line wins with a cashWon of 0
            // https://gamingrealms.atlassian.net/browse/STUDIOEPIC-579
            record.results.forEach((result, index) => {
                if (result instanceof LineResult && result.cashWon <= 0) {
                    record.results[index] = null;
                }
            });
            record.results = record.results.filter(result => result !== null);

            records.push([record]);
        });
        records[records.length - 1][0].lastChild = true;

        commsManager.queueRecords(FreespinRequestPayload, records);

        return [];
    }
}
